/* eslint-disable react/no-unescaped-entities */
import React from "react";
import { Intro } from "../intro";

export function Home() {
    return (
        // <Container>
        //     <IntoContainer>
        //         <Intro />
        //     </IntoContainer>
        //     <Skills />
        //     <MyJorney />
        //     <MyProjects />
        // </Container>
        <Intro />
    );
}
